import React from 'react';

const QuestionAlphaNumeric = ({ phrases, questLabels, dataQuestion, label_no, data, phase }) => {
    var inputProps = {
        colSpan: '2'
    }
    return (
        <div className={`g-item_6 flex_col g2 align-items_start align-self-stretch shown ${phase}`}>
            <p className="small-title m0">{phrases?.["13106"]}</p>
            <div className="full-width flex_col p4 p2_mobile align-items_start g2 align-self-stretch roundness_1 question-brdr">
                <div className="full-width flex_col justify-content_center align-items_center align-self-stretch g2">
                    <div className="g-item_12 input-wrapper disabled">
                        <label className="caption">{questLabels[0]}</label>
                        <input placeholder="Placeholder text" type="text" value={dataQuestion[0]} />
                    </div>
                    <div className="g-item_12 input-wrapper disabled">
                        <label className="caption">{questLabels[1]}</label>
                        <input placeholder="Placeholder text" type="text" value={dataQuestion[1]} />
                    </div>
                    <div className="g-item_12 flex g2 align-items_start align-self-stretch flex_col_tablet">
                        <div className=" disabled width_50 full-width_tablet">
                            <label className="caption">{questLabels[2]}</label>
                            <input className="min-txt-width" placeholder="Placeholder text" disabled type="text" value={dataQuestion[2]} />
                        </div>
                        <div className=" disabled width_50 full-width_tablet">
                            <label className="caption">{questLabels[3]}</label>
                            <input className="min-txt-width" placeholder="Placeholder text" disabled type="text" value={dataQuestion[3]} />
                        </div>
                    </div>
                    <div className="g-item_12 flex g2 align-items_start align-self-stretch  flex_col_tablet">
                        <div className=" disabled width_50 full-width_tablet">
                            <label className="caption">{questLabels[4]}</label>
                            <input className="min-txt-width" placeholder="Placeholder text" disabled type="text" value={dataQuestion[4]} />
                        </div>
                        <div className=" disabled width_50 full-width_tablet">
                            <label className="caption">{questLabels[5]}</label>
                            <input className="min-txt-width" placeholder="Placeholder text" disabled type="text" value={dataQuestion[5]} />
                        </div>
                    </div>
                </div>
            </div>
        </div>);
};

export default QuestionAlphaNumeric;